import type { ApiDashboardElement } from '@highimpact-frontend/api-types';

import UnconfiguredWidgetPlaceholder from '../../commons/UnconfiguredWidgetPlaceholder';

export interface LegacyTableReconfigurePlaceholderProps {
  readonly element: ApiDashboardElement;
  readonly gridId: number;
  readonly gridType: 'grids' | 'reports';
  readonly dashboardElementId: number;
}

/** Prompts migration from deprecated DataSeries/Decimated table configs. */
export default function LegacyTableReconfigurePlaceholder({
  element,
  gridId,
  gridType,
  dashboardElementId,
}: LegacyTableReconfigurePlaceholderProps) {
  const configType = (
    element.properties as { config?: { type?: string } } | undefined
  )?.config?.type;

  const legacyLabel =
    configType === 'DecimatedSeriesTable'
      ? 'tableau de séries décimées'
      : 'tableau de séries';

  return (
    <UnconfiguredWidgetPlaceholder
      message={`Ce ${legacyLabel} n'est plus pris en charge. Reconfigurez-le en tableau d'agrégation pour afficher à nouveau les données.`}
      gridId={gridId}
      gridType={gridType}
      widgetId={dashboardElementId}
      elementType="table"
      configPanelState="Reconfiguring"
    />
  );
}
